import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { motion } from 'motion/react';
import MenuData from '../../currentMenu.json'
import CurrentMenu from '../../foodTruckMenu.json'
import { ItemIds } from '../content/menu-items'
import { PricingTable, Pricing } from '../content/menu-items';
import Brisket from '../assets/brisket.webp'
import BrisketBurntEnds from '../assets/brisketBurntEnds.webp'
import Tritip from '../assets/tritip.webp'
import PulledPork from '../assets/pulledPork.webp'
import PulledPorkBirria from '../assets/pulledPorkBirria.webp'
import PorkBelly from '../assets/porkBelly.webp'
import ChickenBreast from '../assets/chickenBreast.webp'
import FiletMignon from '../assets/filetMignon.webp'
import Rice from '../assets/rice.webp'
import Tzatziki from '../assets/tzatziki.webp'
import CabbageSalad from '../assets/cabbageSalad.webp'
import TritipChili from '../assets/chili.webp'
import Hummus from '../assets/hummus.webp'
import Taco from '../assets/taco.webp'
import Burrito from '../assets/burrito.webp'
import Plate from '../assets/plate.webp'

const itemImages = [ Tritip, Brisket, BrisketBurntEnds, PulledPork, PulledPorkBirria, TritipChili, Tzatziki, CabbageSalad, TritipChili,  FiletMignon, ChickenBreast, PorkBelly,]


const FoodTruckMenu: React.FC = () => {
 
  return (
    <Box sx={{
      textAlign: 'center',
      alignItems:'center',
      justifyContent:'center',
      maxWidth:'800px',
      m:'auto',
      pt:'60px',
      pb:'60px',
      color: 'white'
    }}>
      <h1>Food Truck Menu</h1>
      <Box sx={{color:'#c52020', margin: 'auto', marginBottom: '50px', width: {xs:'90vw', md: 'auto'},}}>
        <span style={{color: '#ffdd22'}}>
          Order for pickup!
        </span> Text (818) 293 - 9445 or DM @charcoalcraze on instagram with your name, order and when you would like to pick it up.
      </Box>
  

      <p style={{fontWeight:'bold', paddingBottom:'10px'}}>Get any of our proteins as a Taco, Burrito, Plate or Half-Plate!</p>
      <Grid container justifyContent='space-evenly' alignItems='space-evenly' mb='40px' spacing={2}>
        <Grid item>
          <motion.img 
            src={Taco}
            whileTap={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
            whileFocus={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
            whileHover={{ scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60 }}
            alt="Pulled Pork Birria Taco." 
            style={{
              position: 'relative',
              zIndex: 55,
              maxWidth:'200px',
              borderRadius: '12px',
              filter: 'drop-shadow(0px 5px 5px black)'
            }} 
          />
        </Grid>
        <Grid item>
          <motion.img 
            src={Burrito} 
            alt="Brisket Burrito." 
            whileTap={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
            whileFocus={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
            whileHover={{ scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60 }}
            style={{
              position: 'relative',
              zIndex: 55,
              maxWidth:'200px',
              borderRadius: '12px',
              filter: 'drop-shadow(0px 5px 5px black)'
            }} 
          />
        </Grid>
        <Grid item>
          <motion.img 
            src={Plate}
            whileTap={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
            whileFocus={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
            whileHover={{ scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60 }}
            alt="Plate with Brisket Burnt Ends, Pulled Pork Birria, Carrot and Cabbage Salad, Tzatziki, Rice and Pickled Onions." 
            style={{
              position: 'relative',
              zIndex: 55,
              maxWidth:'200px',
              borderRadius: '12px',
              filter: 'drop-shadow(0px 5px 5px black)'
            }} 
          />
        </Grid>
      </Grid>

          <p>All plates come with rice, tzatziki and cabbage salad.</p>
      <Grid container justifyContent='center' alignItems='center' mb='40px'>
        <Grid item>
          <motion.img
            whileTap={{scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60}}
            whileFocus={{scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60}}
            whileHover={{ scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60 }} 
            src={Rice} 
            alt="rice" 
            style={{
              maxWidth:'200px'
            }} 
          />
        </Grid>
        <Grid item>
          <motion.img
           whileTap={{scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60}}
            whileFocus={{scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60}}
            whileHover={{ scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60 }}
            src={Tzatziki} 
            alt="taztziki" 
            style={{
              maxWidth:'200px'
            }} 
          />
        </Grid>
        <Grid item>
          <motion.img
            whileTap={{scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60}}
            whileFocus={{scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60}}
            whileHover={{ scale: 1.3, filter: 'drop-shadow(0px 5px 8px rgba(0,0,0,1))', zIndex: 60 }}
            src={CabbageSalad} 
            alt="cabbage salad" 
            style={{
              maxWidth:'200px'
            }} 
          />
        </Grid>
      </Grid>

      <Box>
        {CurrentMenu.menu.map((item, index) => (
          <Box key={item.id}>
          { item.isAvailable &&
          <Grid 
            container 
            p={2}
            m={{xs: '0px', md: '15px'}} 
            sx={{ 
              backgroundColor: index % 2 == 0?'black':'#1d1d1d', 
              border: { xs: 'none', md: index % 2 == 0?'1px solid #c0c0c0':'1px solid #d0d0d0'},
              borderRadius: { xs: '0px', md:'8px' },
              filter: 'drop-shadow(0px 5px 5px black)'
            }}
          >
            
            <Grid
                item 
                xs={12} md={6} m='auto' p={2}
                 borderRadius={{md:'12px 0px 0px 12px', xs:'12px 12px 0px 0px'}}
            >
                <motion.img 
                  src={itemImages[item.id]} 
                  style={{ width: '100%', filter: 'drop-shadow(0px 8px 8px black)', borderRadius:'12px' }}
                  whileTap={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
                  whileFocus={{scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60}}
                  whileHover={{ scale: 1.5, filter: 'drop-shadow(0px 5px 10px rgba(0,0,0,1))', zIndex: 60 }}
                />
            </Grid>

            <Grid
                item 
                xs={12} md={6} p={2}
                 borderRadius={{md:'0px 12px 12px 0px', xs:'0px 0px 0px 0px'}}
            >
                <Typography  mb={1} sx={{ color: 'white', fontWeight: 'bold', fontSize: '24px', textAlign: 'left' }}>
                    {item.name}
                </Typography>
                <Typography sx={{ color: 'white', textAlign: 'left', fontSize: '16px' }} mb={2}>
                    {item.description}
                </Typography>

                <Grid container xs={12}  
                  sx={{ color: "white", border: '1px solid white', padding: '5px' }}
                  textAlign='left'
                  justifyContent='space-evenly'
                  width='100%'
                >
                  <Grid item>
                      <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                          Taco 
                      </Grid>
                      <Grid item>
                          ${PricingTable[item.id].Taco}
                      </Grid>
                  </Grid>

                  <Grid item>
                      <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                          Burrito 
                      </Grid>
                      <Grid item>
                          ${PricingTable[item.id].Burrito}
                      </Grid>
                  </Grid>
          
                  <Grid item>
                      <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                          Plate 
                      </Grid>
                      <Grid item>
                          ${PricingTable[item.id].Plate}
                      </Grid>
                  </Grid>
              
                  <Grid item>
                      <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                          Half Plate 
                      </Grid>
                      <Grid item>
                          ${PricingTable[item.id].HalfPlate}
                      </Grid>
                  </Grid>

                  <Grid item>
                      <Grid item sx={{fontWeight: 'bold', mr: '5px'}}>
                          A La Carte 
                      </Grid>
                      <Grid item>
                          ${PricingTable[item.id].ALaCarte}
                      </Grid>
                  </Grid>
              </Grid>
            </Grid>
          </Grid>
          }
          </Box>
        ))}

      <Grid 
          container 
          p={2}
          m={{xs: '0px', md: '15px'}} 
          sx={{ 
            backgroundColor: '#A1d1d1d', 
            border: { xs: 'none', md: '1px solid #c0c0c0'},
            borderRadius: { xs: '0px', md:'8px' },
            filter: 'drop-shadow(0px 5px 5px black)'
          }}
        >
          
          <Grid
            item 
            xs={12} md={8} m='auto' p={2}
            borderRadius={{md:'12px 0px 0px 12px', xs:'12px 12px 0px 0px'}}
          >
            <Grid container>
              <Typography width='90%' mb={1} sx={{ color: 'white', fontWeight: 'bold', fontSize: '24px', textAlign: 'center' }}>
                  Odin's All Platter
              </Typography>
              <Typography width="8%" mb={1} sx={{ color: 'white', fontWeight: 'bold', fontSize: '24px', textAlign: 'center' }}>
                  $25
              </Typography>
            </Grid>

            <Grid
              item 
              xs={12} md={12} p={2} textAlign='center'
              borderRadius={{md:'0px 12px 12px 0px', xs:'0px 0px 0px 0px'}}
            >
              <Typography sx={{ color: 'white', textAlign: 'left', fontSize: '16px' }} mb={2}>
                  This platter comes with a helping of every protein and side we serve (Image coming soon).
              </Typography>
            </Grid>
          </Grid>
        </Grid>

        <Grid 
          container 
          p={2}
          m={{xs: '0px', md: '15px'}} 
          sx={{ 
            backgroundColor: 'black', 
            border: { xs: 'none', md: '1px solid #c0c0c0'},
            borderRadius: { xs: '0px', md:'8px' },
            filter: 'drop-shadow(0px 5px 5px black)'
          }}
        >
           <Grid
            item 
            xs={12} md={8} m='auto' p={2}
            borderRadius={{md:'12px 0px 0px 12px', xs:'12px 12px 0px 0px'}}
          >
            <Grid container>
              <Typography width='90%' mb={1} sx={{ color: 'white', fontWeight: 'bold', fontSize: '24px', textAlign: 'center' }}>
                  Variety Platter
              </Typography>
              <Typography textAlign='right' width="10%" mb={1} sx={{ color: 'white', fontWeight: 'bold', fontSize: '24px', textAlign: 'center' }}>
                  $15
              </Typography>
            </Grid>

            <Grid
              item 
              xs={12} md={12} p={2} textAlign='center'
              borderRadius={{md:'0px 12px 12px 0px', xs:'0px 0px 0px 0px'}}
            >
              <Typography sx={{ color: 'white', textAlign: 'left', fontSize: '16px' }} mb={2}>
                  This platter comes with a choice of one of our proteins, rice, cabbage salad, tzatziki, and mashed potatoes.
              </Typography>
            </Grid>
          </Grid>
        </Grid>

      </Box>
      
    </Box>
  );
};

export default FoodTruckMenu;
